import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent {
  user: any = null;
  logoutModalOpen: boolean = false;

  constructor(
    private storeManager: AppLocalStorage,
    private toastr: ToastrService,
    private router: Router,
  ) { 
    this.user = this.storeManager.getFromStorage('logged-in-customer') || null;
  }

  logout = () => {
    localStorage.clear();
    sessionStorage.clear();
    this.logoutModalOpen = false
    this.toastr.success("You have been logged out successfully", "Success");
    if(this.router.url === "/payments/wcis") {
      window.location.reload();
    }
    else{
      this.router.navigate(["/payments/wcis"]);
    }
  };

}
